export enum ResetPasswordTranslations {
  title = 'resetPassword.title',
  description = 'resetPassword.description',
  buttonResetPassword = 'resetPassword.buttonResetPassword',
  backToLogIn = 'resetPassword.backToLogIn',
  textLabelNewPass = 'resetPassword.textLabelNewPass',
  textLabelConfirmPass = 'resetPassword.textLabelConfirmPass',
  successMessage = 'resetPassword.successMessage',
}
